import uniqueId from 'lodash.uniqueid';
import {COUNTRY} from 'front-onceforall-core/dist/utils/country';
import {PROJECT_STATUS, projectType, CONSULTANT_ROLE, MANAGE_PROJECT_PERMISSION, MANAGER_ROLE, INVITING_ROLE} from '../../utils/constant';
import {anInternalNote} from '../../utils/fixtures';

const projectsInDb = [{
  projectId: 1,
  name: 'Incity',
  internalReference: 'ref1234',
  address: {
    addressLine: '55, rue de la Republique',
    city: 'Lyon',
    department: 'Rhone',
    region: 'Rhone Alpes Auvergne',
    postCode: '69003'
  },
  country: COUNTRY.FRANCE,
  openingDate: '2017-01-15',
  ownerOrganisation: {
    organisationId: 1,
    country: COUNTRY.GERMANY,
    fullName: 'Organisation 1',
    registrationNumber: '123456',
    businessLine: 'OTHER',
    address: {
      addressLine: '50, rue de l\'oie',
      postCode: '69300',
      city: 'Lyon'
    }
  },
  provisionalAcceptanceDate: null,
  additionalNotes: null,
  creationDate: '2019-01-15T17:00:15Z',
  projectStatus: PROJECT_STATUS.ACTIVE,
  projectType: projectType.STANDARD,
  closingDate: null
},
{
  projectId: 42,
  name: 'Tour Eiffel',
  internalReference: 'refTF',
  address: {
    addressLine: 'Avenue des Champs Elysées',
    city: 'PARIS',
    department: 'Paris',
    region: 'Ile-de-France',
    postCode: '75000'
  },
  country: COUNTRY.FRANCE,
  openingDate: '2001-09-28',
  ownerOrganisation: {
    organisationId: 1,
    fullName: 'ALG',
    country: COUNTRY.GERMANY,
    registrationNumber: '52773773',
    businessLine: 'OTHER',
    address: {
      addressLine: '20, boulevard eugène deruelle',
      postCode: '69003',
      city: 'Lyon'
    }
  },
  provisionalAcceptanceDate: null,
  additionalNotes: null,
  creationDate: null,
  projectStatus: PROJECT_STATUS.ACTIVE,
  projectType: projectType.NOMINATIVE,
  closingDate: null
},
{
  projectId: 43,
  name: 'Britannia 6',
  internalReference: 'refB6',
  address: {
    addressLine: 'Bd Eugène Deruelle',
    city: 'LYON',
    department: 'Rhone',
    region: 'Auvergne Rhone-Alpes',
    postCode: '69000'
  },
  country: COUNTRY.SPAIN,
  openingDate: '2001-09-28',
  ownerOrganisation: {
    organisationId: 1,
    fullName: 'ALG',
    country: COUNTRY.GERMANY,
    registrationNumber: '52773773',
    businessLine: 'OTHER',
    address: {
      addressLine: '20, boulevard eugène deruelle',
      postCode: '69003',
      city: 'Lyon'
    }
  },
  provisionalAcceptanceDate: null,
  additionalNotes: null,
  creationDate: null,
  projectStatus: PROJECT_STATUS.ACTIVE,
  projectType: projectType.STANDARD,
  closingDate: null
}];

const projectUserPermissionsInDb = [
  {
    projectUserPermissionId: 10,
    organisationId: 5,
    projectId: 2,
    user: {
      userId: '8b081608-b225-4a39-a150-71e958f2596b',
      fullName: 'John Doe',
      organisationRole: CONSULTANT_ROLE,
      organisationPermissions: []
    },
    viewProject: true
  },
  {
    projectUserPermissionId: 11,
    organisationId: 5,
    projectId: 2,
    user: {
      userId: 'some-uuid',
      fullName: 'Mark Doe',
      organisationRole: MANAGER_ROLE,
      organisationPermissions: [MANAGE_PROJECT_PERMISSION]
    },
    viewProject: true
  },
  {
    projectUserPermissionId: 12,
    organisationId: 5,
    projectId: 2,
    user: {
      userId: '8b081608-b225-4a39-a150-71e958f2596c',
      fullName: 'Stephane Doe',
      organisationRole: INVITING_ROLE,
      organisationPermissions: [MANAGE_PROJECT_PERMISSION]
    },
    viewProject: true
  },
  {
    projectUserPermissionId: 13,
    organisationId: 5,
    projectId: 2,
    user: {
      userId: '8b081608-b225-4a39-a150-71e958f2596d',
      fullName: 'Jorge Doe',
      organisationRole: MANAGER_ROLE,
      organisationPermissions: [MANAGE_PROJECT_PERMISSION]
    },
    viewProject: false
  }
];

export const findProject = projectId => projectsInDb.find(project => project.projectId === projectId);

const internalNotesInDB = [];
(() => {
  for (let i = 0; i < 10; i++) {
    internalNotesInDB.push(anInternalNote({id: i + 1}));
  }
})();

export default class FakeProjectService {
  createProjectWithDefaultIntervention(project) {
    const response = {...project, projectId: Number(uniqueId())};
    projectsInDb.push(response);
    return Promise.resolve(response);
  }

  updateProject(selectedProject, projectId) {
    const index = projectsInDb.findIndex(project => project.projectId === projectId);
    projectsInDb[index] = selectedProject;
    const projectUpdated = projectsInDb.find(project => project.projectId === projectId);
    return Promise.resolve(projectUpdated);
  }

  findOne(projectId) {
    return Promise.resolve(projectsInDb.find(project => project.projectId === projectId));
  }

  closeProject(projectId) {
    const project = projectsInDb.find(projectItem => projectItem.projectId === projectId);
    project.projectStatus = PROJECT_STATUS.CLOSED;
    project.closingDate = '2019-01-15T17:00:15Z';
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(project);
      }, 0);
    });
  }

  getInternalNotes() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(internalNotesInDB);
      }, 0);
    });
  }

  createInternalNote() {
    return new Promise(resolve => {
      internalNotesInDB.push(anInternalNote());
      setTimeout(() => {
        resolve();
      }, 0);
    });
  }

  getProjectUserPermissions(projectId, organisationId) {
    const projectUserPermissions = projectUserPermissionsInDb.filter(projectUserPermission => projectUserPermission.projectId === projectId && projectUserPermission.organisationId === organisationId);
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(projectUserPermissions);
      }, 0);
    });
  }

  upgradeProject() {
    return Promise.resolve();
  }

  cancelPendingIntervention() {
    return Promise.resolve();
  }

  isProjectReady() {
    return Promise.resolve();
  }

  isProjectCreated() {
    return Promise.resolve();
  }

  updateProjectRequiredDocumentsAlreadyDone(_projectId, _data) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 0);
    });
  }

  isPostCodeValid(_country, _postCode) {
    return Promise.resolve(true);
  }
}
